import React, { useCallback, useEffect, useRef, useState } from "react";
import { useAppDispatch } from "src/redux/hooks";
import { getLabTestsRequest } from "src/redux/slices/labTestSlice";
import CategoryTestListView from "./CategoryTestListView";
import { useNavigate, useParams } from "react-router-dom";
import InfinitePaginatedList from "src/components/common/Pagination/InfinitePaginatedList";
import { LabTestListData } from "src/types/labTests.types";
import Loader from "src/components/common/Loader";
interface LabTestListProps {
  testIdsPresentInCart: { lab_test_name: string }[];
  cartCount: number;
  onCartUpdate: () => void;
}

const LabTestList: React.FC<LabTestListProps> = ({
  testIdsPresentInCart,
  cartCount,
  onCartUpdate,
}) => {
  const dispatch = useAppDispatch();
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const params = useParams();
  const supportProgramKey = params["support-program-key"];
  const navigate = useNavigate();

  const fetchLabTests = useCallback(
    (page: number): Promise<{ items: any[]; hasMore: boolean }> => {
      return new Promise((resolve, reject) => {
        dispatch(
          getLabTestsRequest({
            resolve,
            reject,
            payload: {
              page: String(page),
              // support_program_type: getSupportProgramType(
              //   supportProgramKey || ""
              // ),
              // Info: below parameters might be used in future for GFC
              //support_program_type: ""
              //search: ""
              //separate: "Yes",
            },
          }),
        );
      }).then((res: any) => {
        const items = res?.data || [];
        const hasMore = items.length === 10;
        return { items, hasMore };
      });
    },
    [dispatch],
  );

  return (
    <div
      id="appointment-scroll-container"
      ref={scrollContainerRef}
      className="h-full overflow-y-auto space-y-3"
    >
      <InfinitePaginatedList
        fetchData={fetchLabTests}
        containerHeight="100%"
        scrollableTarget="appointment-scroll-container"
        renderItem={(testCategory: LabTestListData, index: number) => (
          <div key={index} className="p-4">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-primary">
                {testCategory.category_name}
              </h2>
              <span
                className="text-sm font-medium cursor-pointer"
                style={{ color: "var(--app-primary)" }}
                onClick={() => {
                  navigate(
                    `/app/${supportProgramKey}/book-lab-test/${testCategory.category_name}`,
                    {
                      state: {
                        category_list: testCategory.catalogs_list,
                        testIdsPresentInCart,
                        cartCount,
                      },
                    },
                  );
                }}
              >
                View all
              </span>
            </div>

            <CategoryTestListView
              category_list={testCategory.catalogs_list}
              viewAll={false}
              testIdsPresentInCart={testIdsPresentInCart}
              cartCount={cartCount}
              onCartUpdate={onCartUpdate}
            />
          </div>
        )}
        emptyMessage={
          <div className="flex justify-center items-center h-full">
            <p className="text-gray-500">No tests found</p>
          </div>
        }
        loader={
          <div className="flex justify-center items-center py-4 h-full">
            <Loader />
          </div>
        }
      />
    </div>
  );
};

export default LabTestList;
